"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBodyScrollLock = void 0;
const react_1 = require("react");
const bodyScrollLock_1 = require("../utils/bodyScrollLock");
/**
 * @deprecated Use import from @uxf/core-react instead.
 */
function useBodyScrollLock(containerRef, isOpen, { allowTouchMove, clearAllOnClose, reserveScrollBarGap } = {}) {
    (0, react_1.useEffect)(() => {
        const node = containerRef.current;
        if (isOpen && node) {
            (0, bodyScrollLock_1.disableBodyScroll)(node, {
                allowTouchMove: allowTouchMove ||
                    ((element) => {
                        var _a;
                        while (element !== document.body) {
                            if (element.getAttribute("data-body-scroll-lock-ignore") !== null) {
                                return true;
                            }
                            element = (_a = element.parentElement) !== null && _a !== void 0 ? _a : element;
                        }
                        return false;
                    }),
                reserveScrollBarGap,
            });
        }
        return () => {
            if (node) {
                (0, bodyScrollLock_1.enableBodyScroll)(node);
            }
            if (clearAllOnClose) {
                (0, bodyScrollLock_1.clearAllBodyScrollLocks)();
            }
        };
    }, [allowTouchMove, clearAllOnClose, containerRef, isOpen, reserveScrollBarGap]);
}
exports.useBodyScrollLock = useBodyScrollLock;
